import { create } from 'zustand'

// TODO(post-launch): Modal and Drawer state appear unused — no consumers found. Remove if not needed after full integration.
interface ModalState {
  /** Currently open modal ID, or null if none */
  activeModal: string | null
  /** Arbitrary props passed to the active modal */
  modalProps: Record<string, unknown>
}

// TODO(post-launch): Drawer state appears unused — no consumers found. Remove if not needed after full integration.
interface DrawerState {
  /** Currently open drawer ID, or null if none */
  activeDrawer: string | null
  /** Arbitrary props passed to the active drawer */
  drawerProps: Record<string, unknown>
}

interface ConsentState {
  /** Whether the user has accepted cookie/analytics consent */
  consentGiven: boolean
}

interface UIState extends ModalState, DrawerState, ConsentState {
  // Modal actions
  openModal: (id: string, props?: Record<string, unknown>) => void
  closeModal: () => void

  // Drawer actions
  openDrawer: (id: string, props?: Record<string, unknown>) => void
  closeDrawer: () => void

  // Consent actions
  setConsent: (given: boolean) => void
}

export const useUIStore = create<UIState>((set) => ({
  // Modal state
  activeModal: null,
  modalProps: {},
  openModal: (id, props = {}) => set({ activeModal: id, modalProps: props }),
  closeModal: () => set({ activeModal: null, modalProps: {} }),

  // Drawer state
  activeDrawer: null,
  drawerProps: {},
  openDrawer: (id, props = {}) => set({ activeDrawer: id, drawerProps: props }),
  closeDrawer: () => set({ activeDrawer: null, drawerProps: {} }),

  // Consent state
  consentGiven: false,
  setConsent: (given) => set({ consentGiven: given }),
}))
